module.exports = __webpack_public_path__ + "static/media/Privacy_policy.0adfa52b.pdf";